export const DEFAULT_AVATAR_SIZE = 34;
